import React from "react";
import IconButton from "../IconButton";

const ModalCloseButton = ({ onClick, className }) => {
  return (
    <IconButton
      onClick={onClick}
      size="tiny"
      icon="close"
      className={className}
    />
  );
};

export default ModalCloseButton;
